import DepositTopupWrapper from "@/modules/savings/topup-deposite/DepositTopupWrapper";

const DepositTopupPage = () => {
  return <DepositTopupWrapper />;
};

export default DepositTopupPage;
